import React, { forwardRef } from 'react'
import {
  Popup,
  Button as SemanticButton,
  ButtonProps as SemanticButtonProps,
  SemanticShorthandItem,
  StrictPopupHeaderProps
} from 'semantic-ui-react'

import { useCan } from '../../hooks/useCan'

interface ButtonProps extends SemanticButtonProps {
  can?: string[]
  popup?: string
  basicPopup?: boolean
  disabledPopup?: boolean
  flowingPopup?: boolean
  headerPopup?: SemanticShorthandItem<StrictPopupHeaderProps>
  hideOnScrollPopup?: boolean
  hoverablePopup?: boolean
  invertedPopup?: boolean
}

export const Button = forwardRef<SemanticButton, ButtonProps>(
  (
    {
      can,
      popup,
      basicPopup,
      disabledPopup,
      flowingPopup,
      headerPopup,
      hideOnScrollPopup,
      hoverablePopup,
      invertedPopup,
      ...props
    },
    ref
  ) => {
    const canDoIt = useCan(can || [])

    if (!canDoIt) return null

    const button = <SemanticButton ref={ref} {...props} />

    const popupProps = {
      content: popup,
      basic: basicPopup,
      disabled: disabledPopup,
      flowing: flowingPopup,
      header: headerPopup,
      hideOnScroll: hideOnScrollPopup,
      hoverable: hoverablePopup,
      inverted: invertedPopup,
      trigger: button
    }

    return popup ? <Popup {...popupProps} /> : button
  }
)
